export const JSON_ONE1 = {
   
  
    "uniqueLoginKey": "xxxx",
    "merchantId": "201806130002",
    "fcmKey": "",
    "agId": "paygate",
    "userId": "viraj808",
    "merchantKey": "xxxx",
    "qrCodeImageUrl": "https://.com/agmerchant/sdk/viewSdkQrImage/QR_20181120113047915",
    "sessionKey": "xxxx"
        }

